module.exports = __webpack_public_path__ + "static/media/add-employees.b93e1987.svg";